export default "__VITE_ASSET__DuBFMd4v__"